// extracted by mini-css-extract-plugin
export var closeIcon = "file-to-big-size-pill-module--close-icon--f00fc";
export var folderWrapper = "file-to-big-size-pill-module--folder-wrapper--c14f5";
export var pillText = "file-to-big-size-pill-module--pill-text--be30c";
export var wrapper = "file-to-big-size-pill-module--wrapper--4b1ed";